<div class='good-average-poor-card'>
  <mat-card class='card-body card-appearance' fxFlex='auto' style='padding-bottom: 0px'>
    <div fxLayout='row'>
      <div
        class='card-header margin-t-10'
        style='margin-right: 30px; width: 130px'
        fxLayout='column'
        fxLayoutAlign='start center'
      >
        <img *ngIf='titleIconName' [src]="cService.mentorAssetRoot + titleIconName + '.png'" width='50%' />
        <div class='bold margin-t-10 text-align-c'>{{ cardTitle | uppercase }}</div>
      </div>

      <div fxFlex='auto'>
        <div class='margin-b-15' *ngFor='let score of scores' fxLayout='row'>
					<span [style.color]='score.color'>
						<mat-icon *ngIf="score.verbalRating.toLowerCase() === 'good'" class='face-icons'>mood</mat-icon>
						<mat-icon *ngIf="score.verbalRating.toLowerCase() === 'average'" class='face-icons'
            >sentiment_satisfied</mat-icon
            >
						<mat-icon *ngIf="score.verbalRating.toLowerCase() === 'poor'" class='face-icons'
            >mood_bad</mat-icon
            >
					</span>

          <div fxLayout='column' fxFlex='auto'>
            <div>
              <span [style.color]='score.color'>{{ score.verbalRating | uppercase }}</span>
              <span fxFlex='auto'></span> <span>{{ score.percentageRating }} %</span>
            </div>

            <!-- TODO: If this would be reused in future, then convert to a component -->
            <div style='height: 4px; background-color: rgb(236, 236, 236)' class='margin-t-5'>
              <div
                style='height: 4px'
                *ngIf='score.percentageRating'
                [style.background-color]='score.color'
                [fxFlex]='score.percentageRating'
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
</div>
